export const HTML_VIDEO_PRESET = {
    DEFAULT: "default",
    DEFAULT_HIGH_QUALITY: "default_high_quality",
    H264_SRGB_22M: "h264_srgb_22m",
    H265_10BIT_22M: "h265_10bit_22m",
    CUSTOM: "custom",
} as const;

export type HtmlVideoPresetType = (typeof HTML_VIDEO_PRESET)[keyof typeof HTML_VIDEO_PRESET];

export const HTML_VIDEO_ENCODING_FORMAT = {
    MP4: "mp4",
    MOV: "mov",
} as const;

export type HtmlVideoEncodingFormatType = (typeof HTML_VIDEO_ENCODING_FORMAT)[keyof typeof HTML_VIDEO_ENCODING_FORMAT];

export type HtmlVideoPresetMetadata = {
    label: string;
    description: readonly string[];
};

export const HTML_VIDEO_PRESET_METADATA = {
    [HTML_VIDEO_PRESET.DEFAULT]: {
        label: "Default",
        description: [
            "Codec: H.264 (libx264)",
            "Quality: CRF 19, fast preset",
            "Bit depth: 8-bit, 4:2:0 chroma subsampling",
            "Colour: BT.709 tagged, full range",
            "Audio: AAC (when Capture Audio is on)",
        ],
    },
    [HTML_VIDEO_PRESET.DEFAULT_HIGH_QUALITY]: {
        label: "Default High Quality (uncompressed)",
        description: [
            "Codec: H.264 (libx264), lossless (CRF 0)",
            "Bit depth: 8-bit, 4:2:0 chroma subsampling",
            "Colour: BT.709 tagged, full range",
            "Audio: AAC (when Capture Audio is on)",
            "Very large files, intended for manual re-encoding",
        ],
    },
    [HTML_VIDEO_PRESET.H264_SRGB_22M]: {
        label: "H.264 — colour accurate (22 Mbps)",
        description: [
            "Codec: H.264 (libx264), medium preset",
            "Bitrate: constant 22 Mbps",
            "Bit depth: 8-bit, 4:2:0 chroma subsampling",
            "Colour: BT.709 tagged, full range",
            "Audio: AAC (when Capture Audio is on)",
        ],
    },
    [HTML_VIDEO_PRESET.H265_10BIT_22M]: {
        label: "H.265 10-bit (22 Mbps)",
        description: [
            "Codec: H.265 / HEVC (libx265), hvc1 tag",
            "Bitrate: constant 22 Mbps",
            "Bit depth: 10-bit, 4:2:0 chroma subsampling",
            "Colour: full BT.709 (primaries, transfer, matrix)",
            "Audio: AAC (when Capture Audio is on)",
        ],
    },
    [HTML_VIDEO_PRESET.CUSTOM]: {
        label: "Custom",
        description: [
            "Provide your own ffmpeg encoding parameters",
            "Only a safe subset of ffmpeg flags is allowed",
            "Audio: AAC (when Capture Audio is on)",
        ],
    },
} as const satisfies Record<HtmlVideoPresetType, HtmlVideoPresetMetadata>;
